import { render } from "./CreatorLiteItemDetails.vue?vue&type=template&id=34f876ac"
import script from "./CreatorLiteItemDetails.vue?vue&type=script&lang=js"
export * from "./CreatorLiteItemDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/CreatorLiteItemDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34f876ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34f876ac', __exports__)) {
    api.reload('34f876ac', __exports__)
  }
  
  module.hot.accept("./CreatorLiteItemDetails.vue?vue&type=template&id=34f876ac", () => {
    api.rerender('34f876ac', render)
  })

}


export default __exports__